import { Button, Modal } from 'edozvola-frontend-lib/dist/ui';
import { ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import React from 'react';

export interface IConfirmationModal {
  confirmButtonOnly?: boolean;
  modalOpened: boolean;
  header?: string;
  bodyMessage: string;
  confirmButtonLabel?: string;
  cancelButtonLabel?: string;
  onConfirm: any;
  onCancel?: any;
  loadingStateForConfirmationButton?: any;
  deleteAction?: boolean;
}

export const ConfirmationModal = (props: IConfirmationModal) => {
  return (
    <Modal isOpen={props.modalOpened} centered={true}>
      <ModalHeader>{props.header}</ModalHeader>
      <ModalBody>
        <p dangerouslySetInnerHTML={{ __html: props.bodyMessage }}></p>
      </ModalBody>
      <ModalFooter>
        {!props.confirmButtonOnly && (
          <Button
            size="lg"
            label={props.cancelButtonLabel ? props.cancelButtonLabel : 'Odustani'}
            onClick={props.onCancel}
            color="secondary"
          />
        )}
        <Button label={props.confirmButtonLabel ? props.confirmButtonLabel : 'Potvrdi'} size="lg" onClick={props.onConfirm} color={props.deleteAction ? 'danger' : 'info'} isLoading={!!props.loadingStateForConfirmationButton} />
      </ModalFooter>
    </Modal>
  );
};
